import { memo } from 'react';

export const typedMemo: <T>(c: T, propsAreEqual?: (prevProps: object, nextProps: object) => boolean) => T = memo;
